"use strict";
/**
 * Lake Survey Chart Data Types (Updated)
 *
 * These types represent the JSON output format from the lake survey processing pipeline.
 * The data is structured for generating CPUE time series, length distribution charts,
 * and includes current abundance and lunker potential data.
 */
Object.defineProperty(exports, "__esModule", { value: true });
